import React from 'react';
import './christmas-tree.css';
import { Col } from 'react-bootstrap';

const isTreeActive = (d: Date = new Date()) => {
  const month = d.getMonth() + 1;
  const day = d.getDate();
  return (month === 12 && day >= 20) || (month === 1 && day <= 8);
};
const greetings = (d: Date = new Date()) => {
  const month = d.getMonth() + 1;
  const day = d.getDate();
  if (month === 12 && day >= 20 && day <= 25) return 'Καλά Χριστούγεννα!';
  if (month === 12 && day > 25) return 'Καλή Πρωτοχρονιά!';
  if (month === 1 && day <= 8) return 'Ευτυχισμένο το Νέο Έτος!';
  return '';
};
export const ChristmasTree = ({ isMobile }: { isMobile?: boolean }) => {
  const active = isTreeActive();
  if (!active) return null;
  const greetingsMessage = greetings();
  return (
    <div
      className="container"
      style={{
        maxWidth: isMobile ? '30vw' : '10vw',
        maxHeight: isMobile ? '30vw' : '10vw',
        marginTop: '-7rem',
        marginBottom: '1.6rem',
      }}
    >
      <div className="tree">
        <div className="tree-triangle1"></div>
        <div className="tree-triangle2"></div>
        <div className="tree-triangle3"></div>
        <div className="ornament or1">
          <div className="shine"></div>
        </div>
        <div className="ornament or2">
          <div className="shine"></div>
        </div>
        <div className="ornament or3">
          <div className="shine"></div>
        </div>
        <div className="ornament or4">
          <div className="shine"></div>
        </div>
        <div className="ornament or5">
          <div className="shine"></div>
        </div>
        <div className="ornament or6">
          <div className="shine"></div>
        </div>
        <div className="trunk"></div>
        <div className="star-light"></div>
        <div className="star"></div>
        <div className="star-highlight"></div>
      </div>
      <Col className="text-center" style={{ position: 'absolute', zIndex: '-1', bottom: '-9%' }}>
        {greetingsMessage}
      </Col>
    </div>
  );
};
